export default __webpack_public_path__ + "static/media/Absolute Witchsour.b966579d.jpg";